import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../../components/Landing/Header/headerScc";

import { Footer } from "../../../components/Landing/Footer";
import '../PeopleList.scss';
// style
import "../landing.style.scss";

export const Proximamente = () => {
  // state component


  return (
    <div>
      <Header />
      <HeaderScc />
      <div className="container-fluid2 pt-5" style={{marginTop: '0'}}>
        <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:60}}>
          <strong>
            <h1 className="mb-5" style={{color: '#1e3a53'}}>
              PRÓXIMAMENTE ...
            </h1>
          </strong>
        </div>
        <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:60}}>
          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
      <Footer />
    </div>
  );
};
